import styles from './index.module.css';

const Title = ({ children }: { children: React.ReactNode }) => (
  <span className={styles.title}>{children}</span>
);

export default Title;
